import { RadioLabel } from './RadioLabel';

export const dealOptions = [
  { label: 'Acquisition (Buy side)', value: 1 },
  { label: 'Divestiture (Sell side)', value: 2 },
];

export const defaultRestrictionOption = { label: 'C2', value: 3 };

export const financialMagnitudeOptions = [
  { label: 'Actuals', value: 'Actuals', default: true },
  { label: 'Thousands', value: 'Thousands' },
  { label: 'Millions', value: 'Millions' },
];

export const financialsDecimalCountOptions = [
  { label: 'Show', value: '1', default: true },
  { label: 'Hide', value: '0' },
];

const codeToDisplayName = (
  arrayOfObjects: { value: number; label: string }[],
  code: number
) => {
  const target = arrayOfObjects.filter((o) => o.value === code);
  return target.length !== 0 ? target[0].label : 'Undefined';
};

export const dealCodeToName = (code: number) =>
  codeToDisplayName(dealOptions, code);

export const projectType = {
  buy: { id: 1, text: 'Buy side' },
  sell: { id: 2, text: 'Sell side' },
};
export const getProjectType = (type: number) =>
  type === projectType.buy.id ? projectType.buy.text : projectType.sell.text;

export const getDefaultValue = (
  options: { default: boolean; value: string }[],
  defaultWhere = true
) => (options.find((o) => o.default === defaultWhere) || options[0]).value;

export const consentLevelOptions = [
  {
    label: 'Engagement terms not yet agreed',
    value: 'terms not agreed',
    helperText: '',
  },
  {
    label: 'None',
    value: 'None',
    helperText: '',
  },
  {
    label: 'Partial',
    value: 'Partial',
    helperText: '',
  },
  {
    label: 'Full',
    value: 'Full',
    helperText: '',
  },
];

export const consentLevelOptionsWithLinks = consentLevelOptions.map(
  ({ label, value, helperText }) => ({
    label: <RadioLabel label={label} helperText={helperText} />,
    value,
  })
);

export const clientTargetoptions = [
  { label: 'Yes', value: true, default: true },
  { label: 'No', value: false },
];
